import { Affix, Button, Card, Space } from "antd";
import ListTable from "common/ListTable";
import { getData } from "apiServices/common";
import { alertPop } from "apiServices/common/helper";
import CustomFilter from "components/Common/CustomFilter";
import Header from "components/Common/Header";
import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router";

export default function RemedyLogs() {
  // Router
  const location = useLocation();
  const routerPath = location ? location.pathname : null;
  const [showFilter, setShowFilter] = useState(
    localStorage.getItem("filter_status") && routerPath
      ? JSON.parse(localStorage.getItem("filter_status"))[routerPath]
      : false,
  );
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = async (filter) => {
    setLoading(true);
    setError(null);
    try {
      const response = await getData(
        `/api/digitalization/problem-remedy/remedy-logs`,
        false,
        filter,
      );
      if (response && response?.status === 200) {
        const masterData = response?.data?.data?.data;
        setData(masterData);
        setPagination({
          current: filter?.page,
          pageSize: filter?.pageSize,
          total: response?.data?.data?.total || 0,
        });
      } else {
        alertPop(
          "error",
          response?.message ? response?.message : "Something Went Wrong!",
        );
        setError("Could not load this list.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      alertPop("error", "Failed to fetch data!");
      setError("Could not load this list.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData({
      page: pagination.current,
      per_page: pagination.pageSize,
    });
  }, [pagination.current, pagination.pageSize]);

  const handleTableChange = (pagination) => {
    setPagination({
      ...pagination,
      current: pagination.current,
      pageSize: pagination.pageSize,
    });
  };

  const memoizedCustomFilter = useMemo(
    () => (
      <CustomFilter
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        tableData={data}
        fetchTableData={fetchData}
        filterName="remedy_logs_filter"
      />
    ),
    [showFilter],
  );

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed">
          <Header
            title="Remedy Logs"
            actions={[
              <Affix offsetTop={20}>
                <Space>
                  <Button
                    type={showFilter ? "danger" : "primary"}
                    size="small"
                    onClick={() => setShowFilter((prev) => !prev)}
                    style={{ float: "right" }}
                  >
                    {`${showFilter ? "Close" : "Open"} Filter Option`}
                  </Button>
                </Space>
              </Affix>,
            ]}
          ></Header>
        </Card>
      </Affix>
      <Card>
        {memoizedCustomFilter}
        <ListTable
          style={{ marginTop: "20px" }}
          error={error}
          onRetry={() =>
            fetchData({
              page: pagination.current,
              per_page: pagination.pageSize,
            })
          }
          emptyText="No records to show yet."
          dataSource={data}
          columns={[
            {
              title: "Remedy Unique ID",
              dataIndex: "remedy_unique_id",
              key: "remedy_unique_id",
            },
            {
              title: "Remedy Provider",
              dataIndex: ["remedy_provider", "name"],
              key: "remedy_provider_name",
            },
            {
              title: "Remedy End Time",
              dataIndex: "remedy_end_time",
              key: "remedy_end_time",
            },
            {
              title: "Spent Time (Min)",
              dataIndex: "spent_time_min",
              key: "spent_time_min",
            },
            {
              title: "Department",
              dataIndex: ["remedy_provider_department", "title"],
              key: "department_title",
            },
            {
              title: "Problem Type",
              dataIndex: ["problem_type", "name"],
              key: "problem_type_name",
            },
            {
              title: "Problem",
              dataIndex: ["problem", "name"],
              key: "problem_name",
            },
            {
              title: "Reason",
              dataIndex: ["reason", "name"],
              key: "reason_name",
            },
            {
              title: "Remedy",
              dataIndex: ["remedy", "name"],
              key: "remedy_name",
            },
            {
              title: "Buyer",
              dataIndex: ["buyer", "name"],
              key: "buyer_name",
            },
            {
              title: "Style",
              dataIndex: ["style", "style_no"],
              key: "style_no",
            },
            {
              title: "Substyle",
              dataIndex: ["sub_style", "sub_style_no"],
              key: "sub_style_no",
            },
            {
              title: "Updated By",
              dataIndex: ["updated_by", "name"],
              key: "updated_by_name",
              render: (text) => text || "N/A",
            },
          ]}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
          }}
          loading={loading}
          onChange={handleTableChange}
        />
      </Card>
    </>
  );
}
